module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/fullwidth_desktop-d1c0a5cbbe802b8d7ac87ca05ec9f5dd.jpg";